import { createSlice } from '@reduxjs/toolkit';
import { activityLogsAct } from '../action';
import {
  ActivityLog,
  AgencyActivityLog,
} from '../../../../types/models/activityLogs';
import { NotificationMessageType } from '@nxsys/types/models/Common';
import { GetListActivityLogParams } from '../types';

interface ActivityLogsState {
  eeActivityLogsData: {
    list: ActivityLog[];
    pagination: {
      current: number;
      pageSize: number;
      totalDocs: number;
    };
    queryParams: GetListActivityLogParams | null;
  };
  agencyLogsData: {
    list: AgencyActivityLog[];
    pagination: {
      current: number;
      pageSize: number;
      totalDocs: number;
    };
    queryParams: GetListActivityLogParams | null;
  };
  loading: boolean;
  messageNotification: NotificationMessageType | null;
}

export const initialState: ActivityLogsState = {
  eeActivityLogsData: {
    list: [],
    pagination: {
      current: 0,
      pageSize: 20,
      totalDocs: 0,
    },
    queryParams: null,
  },
  agencyLogsData: {
    list: [],
    pagination: {
      current: 0,
      pageSize: 20,
      totalDocs: 0,
    },
    queryParams: null,
  },
  loading: false,
  messageNotification: null,
};

const activityLogsSlice = createSlice({
  name: 'activityLogsSlice',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    //employee
    builder.addCase(
      activityLogsAct.getListActivityLogEmployeeSubcontract.pending,
      (state) => {
        state.loading = true;
      },
    );
    builder.addCase(
      activityLogsAct.getListActivityLogEmployeeSubcontract.fulfilled,
      (state, action) => {
        state.loading = false;
        state.eeActivityLogsData.pagination = action.payload.pagination;
        state.eeActivityLogsData.list = action.payload.data;
        state.eeActivityLogsData.queryParams = action.payload.queryParams ?? null;
      },
    );
    builder.addCase(
      activityLogsAct.getListActivityLogEmployeeSubcontract.rejected,
      (state) => {
        state.loading = false;
      },
    );
    //agency
    builder.addCase(
      activityLogsAct.getListActivityLogAgency.pending,
      (state) => {
        state.loading = true;
      },
    );
    builder.addCase(
      activityLogsAct.getListActivityLogAgency.fulfilled,
      (state, action) => {
        state.loading = false;
        state.agencyLogsData.pagination = action.payload.pagination;
        state.agencyLogsData.list = action.payload.data;
        state.agencyLogsData.queryParams = action.payload.queryParams ?? null;
      },
    );
    builder.addCase(
      activityLogsAct.getListActivityLogAgency.rejected,
      (state) => {
        state.loading = false;
      },
    );
  },
});

export const activityLogsReducer = activityLogsSlice.reducer;
export const activityLogsAction = {
  ...activityLogsSlice.actions,
  ...activityLogsAct,
};
